import FormattedMessage from 'I18n/components/FormattedMessage';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import { H2 } from 'UIComponents/elements/headings';
import UIFlex from 'UIComponents/layout/UIFlex';
import { jsx as _jsx } from "react/jsx-runtime";
export const FeatureSurveyModalHeader = () => {
  return /*#__PURE__*/_jsx(UIDialogHeader, {
    children: /*#__PURE__*/_jsx(UIFlex, {
      direction: "column",
      align: "center",
      justify: "center",
      className: "text-center",
      children: /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.trialFeatureSurvey.common.trialTitle"
        })
      })
    })
  });
};